var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#3899EC","fillRule":"evenodd","d":"M.222 1.397l4.741 4.4a.791.791 0 0 0 1.061 0l4.74-4.6a.669.669 0 0 0 0-.992.792.792 0 0 0-1.064 0L5.489 4.316l-4.21-3.9a.79.79 0 0 0-1.064 0A.673.673 0 0 0 0 .897c0 .19.08.372.222.5z"}));
}

Arrow.defaultProps = {"width":"11","height":"6","viewBox":"0 0 11 6"};

module.exports = Arrow;

Arrow.default = Arrow;
